import React from 'react';
import { MDBTable, MDBTableBody } from 'mdbreact';

function SetMatchDetailInput({
  setDetailRequests,
  players,
  movedPlayers,
  gameIndex,
  isHome,
  onChange,
}) {
  let prefix = isHome ? 'home' : 'away';
  let sets = [];

  const renderSetTotalPinsInput = (
    setTotalPins,
    idx,
    gameIndex,
    setDetailRequests,
    isHome
  ) => {
    return (
      <td width="45px" height="50px">
        <input
          type="number"
          name={setTotalPins}
          data-id={idx}
          data-gameno={gameIndex}
          id={setTotalPins}
          value={
            isHome
              ? setDetailRequests[idx].homeSetTotalPins
              : setDetailRequests[idx].awaySetTotalPins
          }
          onChange={onChange}
          className={isHome ? 'homeSetTotalPins' : 'awaySetTotalPins'}
        />
      </td>
    );
  };

  const renderSetMissInput = (
    setMiss,
    idx,
    gameIndex,
    setDetailRequests,
    isHome
  ) => {
    return (
      <td width="45px" height="50px">
        <input
          type="number"
          name={setMiss}
          data-id={idx}
          data-gameno={gameIndex}
          id={setMiss}
          value={
            isHome
              ? setDetailRequests[idx].homeSetMiss
              : setDetailRequests[idx].awaySetMiss
          }
          onChange={onChange}
          className={isHome ? 'homeSetMiss' : 'awaySetMiss'}
        />
      </td>
    );
  };

  const renderClassicPinsInput = (
    setClassicPins,
    idx,
    gameIndex,
    setDetailRequests,
    isHome
  ) => {
    return (
      <td width="45px" height="50px">
        <input
          type="number"
          name={setClassicPins}
          data-id={idx}
          data-gameno={gameIndex}
          id={setClassicPins}
          value={
            isHome
              ? setDetailRequests[idx].homeSetClassicPins
              : setDetailRequests[idx].awaySetClassicPins
          }
          onChange={onChange}
          className={isHome ? 'homeSetClassicPins' : 'awaySetClassicPins'}
        />
      </td>
    );
  };

  const renderPlayerSelection = (
    idx,
    playerId,
    gameIndex,
    players,
    movedPlayers,
    setDetailRequests,
    isHome
  ) => {
    if (idx === 0) {
      players.sort(
        (a, b) =>
          a.firstName.localeCompare(b.firstName, 'et') ||
          a.lastName.localeCompare(b.lastName, 'et')
      );
      movedPlayers.sort(
        (a, b) =>
          a.playerFirstName.localeCompare(b.playerFirstName, 'et') ||
          a.playerLastName.localeCompare(b.playerLastName, 'et')
      );
      return (
        <td width="120px">
          <select
            name={playerId}
            data-id={idx}
            data-gameno={gameIndex}
            id={playerId}
            className={isHome ? 'homePlayerId' : 'awayPlayerId'}
            value={
              isHome
                ? setDetailRequests[idx].homePlayerId
                : setDetailRequests[idx].awayPlayerId
            }
            onChange={onChange}
          >
            <option value="" />
            {players.map((player) => (
              <option
                key={'' + gameIndex + '' + isHome + '' + player.id}
                value={player.id}
              >
                {player.firstName} {player.lastName}
              </option>
            ))}
            {movedPlayers.map((movedPlayer) => (
              <option
                disabled
                key={'' + gameIndex + '' + isHome + '' + movedPlayer.playerId}
                value={movedPlayer.playerId}
              >
                {movedPlayer.playerFirstName} {movedPlayer.playerLastName}*
              </option>
            ))}
          </select>
        </td>
      );
    } else {
      return (
        <td width="120px">
          <input
            type="number"
            hidden={true}
            name={playerId}
            data-id={idx}
            data-gameno={gameIndex}
            id={playerId + '-hidden'}
            readOnly={true}
            defaultValue={
              isHome
                ? setDetailRequests[0].homePlayerId
                : setDetailRequests[0].awayPlayerId
            }
            onChange={onChange}
            className={isHome ? 'homePlayerId' : 'awayPlayerId'}
            ref={() => {
              if (isHome) {
                setDetailRequests[idx].homePlayerId =
                  setDetailRequests[0].homePlayerId;
              } else {
                setDetailRequests[idx].awayPlayerId =
                  setDetailRequests[0].awayPlayerId;
              }
            }}
          />
        </td>
      );
    }
  };

  const renderGameTotals = (idx, setDetailRequests, isHome) => {
    const LAST_SET = 3;
    if (idx === LAST_SET) {
      return (
        <tr>
          <td>Mäng kokku</td>
          <td>
            {setDetailRequests
              .slice(idx - 3, idx + 1)
              .map((set) =>
                isHome
                  ? Number(set.homeSetClassicPins)
                  : Number(set.awaySetClassicPins)
              )
              .reduce((accumulator, current) => accumulator + current)}
          </td>
          <td>
            {setDetailRequests
              .slice(idx - 3, idx + 1)
              .map((set) =>
                isHome ? Number(set.homeSetMiss) : Number(set.awaySetMiss)
              )
              .reduce((accumulator, current) => accumulator + current)}
          </td>
          <td>
            {setDetailRequests
              .slice(idx - 3, idx + 1)
              .map((set) =>
                isHome
                  ? Number(set.homeSetTotalPins)
                  : Number(set.awaySetTotalPins)
              )
              .reduce((accumulator, current) => accumulator + current)}
          </td>
        </tr>
      );
    }
  };

  for (let idx = 0; idx < setDetailRequests.length; idx++) {
    let playerId = `${prefix}PlayerId-${idx}`,
      setClassicPins = `${prefix}SetClassicPins-${idx}`,
      setMiss = `${prefix}SetMissPins-${idx}`,
      setTotalPins = `${prefix}SetTotalPins-${idx}`,
      setNo = `setNo-${idx}`;
    sets.push(
      <div key={'' + gameIndex + '' + idx}>
        <div className="match_content">
          <div className="form-group no_bottom_margin">
            <label hidden htmlFor={playerId}>
              Vooru number
            </label>
            <input
              type="number"
              hidden={true}
              readOnly={true}
              name={setNo}
              data-id={idx}
              data-gameno={gameIndex}
              id={setNo}
              defaultValue={setDetailRequests[idx].setNo}
              className="setNo"
              ref={() => {
                setDetailRequests[idx].setNo = idx + 1;
              }}
            />
          </div>
        </div>

        <div className="form-group no_bottom_margin">
          <MDBTable striped className="merged_tables">
            <MDBTableBody>
              <tr>
                {renderPlayerSelection(
                  idx,
                  playerId,
                  gameIndex,
                  players,
                  movedPlayers,
                  setDetailRequests,
                  isHome
                )}
                {renderClassicPinsInput(
                  setClassicPins,
                  idx,
                  gameIndex,
                  setDetailRequests,
                  isHome
                )}
                {renderSetMissInput(
                  setMiss,
                  idx,
                  gameIndex,
                  setDetailRequests,
                  isHome
                )}
                {renderSetTotalPinsInput(
                  setTotalPins,
                  idx,
                  gameIndex,
                  setDetailRequests,
                  isHome
                )}
              </tr>
              {renderGameTotals(idx, setDetailRequests, isHome)}
            </MDBTableBody>
          </MDBTable>
        </div>
      </div>
    );
  }

  return sets;
}

export default SetMatchDetailInput;
